import type { ColDef, ICellRendererParams, ValueGetterParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { IBadgeCellRendererParams } from '~/types/badge'
import type { IGroup } from '~/types/group'
import type { IUserAdminLight } from '~/types/user'

import BadgeCellRenderer from '~/components/CellRenderers/BadgeCellRenderer'
import TeamCellRenderer from '~/components/CellRenderers/TeamCellRenderer'
import { valueComparator } from '~/utils/comparators'
import { badgeColDef, lastUpdateColDef, teamColDef } from '~/utils/table'

import './styles.scss'

const GroupNameCellRenderer = ({ data }: ICellRendererParams): ReactElement => {
  const { description, group_name } = data as IGroup

  return (
    <div className="group-name-cell">
      <span className="group-name-cell__name text">{group_name}</span>
      <span className="group-name-cell__description text">{description}</span>
    </div>
  )
}

const columns: ColDef[] = [
  {
    cellRenderer: GroupNameCellRenderer,
    comparator: valueComparator,
    field: 'group_name',
    filter: 'agTextColumnFilter',
    headerName: 'Group',
    menuTabs: ['filterMenuTab'],
    minWidth: 170,
    resizable: false,
    suppressMovable: true,
    suppressNavigable: true,
    width: 160,
  },
  badgeColDef(BadgeCellRenderer, {
    field: 'roles',
    filterValueGetter: ({ data }: ValueGetterParams<IGroup>): string[] | undefined =>
      data?.roles?.map(({ name }) => name),
    headerName: 'Related roles',
    valueGetter: ({ data }: ValueGetterParams<IGroup>): IBadgeCellRendererParams | undefined => {
      if (!data) return undefined

      const { roles } = data

      return {
        data:
          roles?.map(({ name, role_id }) => ({
            id: role_id,
            name,
          })) || [],
        type: 'role',
      }
    },
  }),
  teamColDef(TeamCellRenderer, {
    field: 'users',
    headerName: 'Member users',
    valueGetter: ({ data }: ValueGetterParams<IGroup>): string[] | undefined =>
      data?.users?.map(({ user_id }: IUserAdminLight) => user_id),
  }),
  lastUpdateColDef({ field: 'updated_at' }),
]

export default columns
